var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJaOsteoporosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2643_1209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 23.9998,
    r: 21.2571,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2643_1209)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.9713,
    cy: 25.0287,
    r: 5.48571,
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685715,
    transform: "matrix(0.983108 -0.183026 -0.183026 -0.983108 16.8496 16.5132)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.011 8.05249C34.2119 8.25333 34.2119 8.57895 34.011 8.7798L28.3362 14.4547C28.1353 14.6555 27.8097 14.6555 27.6088 14.4547C25.889 12.7348 23.0716 12.7348 21.3517 14.4547C19.6318 16.1746 19.6318 18.9919 21.3517 20.7118C21.3559 20.716 21.36 20.7203 21.364 20.7246C22.4497 21.8879 24.0827 22.277 25.4776 21.8895C25.6516 21.8412 25.8383 21.8877 25.9693 22.012C26.1003 22.1364 26.1565 22.3203 26.1173 22.4966C25.8029 23.9116 26.2011 25.5612 27.2885 26.6486C29.0084 28.3685 31.8258 28.3685 33.5456 26.6486C35.2655 24.9287 35.2655 22.1114 33.5456 20.3915C33.3448 20.1906 33.3448 19.865 33.5456 19.6642L39.2205 13.9893C39.4214 13.7884 39.747 13.7884 39.9478 13.9893C40.1487 14.1901 40.1487 14.5157 39.9478 14.7166L34.6195 20.0449C36.3874 22.1821 36.2719 25.377 34.273 27.3759C32.1514 29.4975 28.6827 29.4975 26.5612 27.3759C25.3976 26.2124 24.8826 24.5636 25.0014 23.0279C23.449 23.2106 21.7856 22.6794 20.6181 21.4329C18.5028 19.3107 18.5049 15.8468 20.6244 13.7274C22.6234 11.7284 25.8182 11.6129 27.9554 13.3808L33.2837 8.05249C33.4846 7.85165 33.8102 7.85165 34.011 8.05249Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3472 19.1741C16.6164 19.1203 16.8804 19.2874 16.947 19.5537C17.2719 20.8536 17.9203 21.9949 18.9943 23.0689C19.9839 24.0585 21.2132 24.7922 22.5096 25.1163C22.6938 25.1624 22.8377 25.3062 22.8838 25.4905C23.2078 26.7869 23.9416 28.0162 24.9311 29.0057C25.9073 29.9819 27.1384 30.6434 28.475 31.0611C28.7261 31.1396 28.8775 31.3949 28.8259 31.6529C28.6292 32.6362 28.1378 33.5109 27.3757 34.2729C25.3767 36.2719 22.1819 36.3874 20.0447 34.6195L14.7163 39.9478C14.5155 40.1487 14.1899 40.1487 13.989 39.9478C13.7882 39.747 13.7882 39.4213 13.989 39.2205L19.6639 33.5456C19.8648 33.3448 20.1904 33.3448 20.3912 33.5456C22.1111 35.2655 24.9285 35.2655 26.6484 33.5456C27.1603 33.0337 27.5075 32.4815 27.7028 31.8869C26.4169 31.4257 25.2031 30.7323 24.2038 29.733C23.1708 28.7 22.3717 27.4191 21.9658 26.0343C20.5809 25.6283 19.3 24.8293 18.267 23.7962C17.2068 22.736 16.4983 21.5915 16.0909 20.3047C15.5048 20.5013 14.9599 20.8462 14.4544 21.3517C12.7345 23.0716 12.7345 25.8889 14.4544 27.6088C14.6553 27.8097 14.6553 28.1353 14.4544 28.3361L8.77955 34.011C8.57871 34.2119 8.25308 34.2119 8.05224 34.011C7.8514 33.8102 7.8514 33.4845 8.05224 33.2837L13.3806 27.9554C11.6126 25.8182 11.7281 22.6233 13.7271 20.6244C14.4892 19.8623 15.3638 19.3708 16.3472 19.1741Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(-0.950565 0.310525 0.310525 0.950565 30.7354 31.7412)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.4224,
    y: 30.9756,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "rotate(-78.0909 31.4224 30.9756)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0681,
    y: 17.1816,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "rotate(109.454 16.0681 17.1816)",
    fill: "#5096E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaOsteoporosis);
export default __webpack_public_path__ + "static/media/ja_osteoporosis.533ea9f15235288ed3520c40635517b6.svg";
export { ForwardRef as ReactComponent };